export const getCookieValidityDomain = ({
  origin,
}: URL): string | undefined => {
  return origin.match(/\.(develop|master|rossum)\.(.*)/)?.[0];
};
